export const getServicesMinPrice = (row) => {
    let minPrice = null;
    row.parts.forEach(part => {
        if (part.service.seatService && (!minPrice || part.service.minPrice.amount < minPrice)) {
            minPrice = part.service.minPrice.amount;
        }
    });
    return minPrice;
};
